import { render, staticRenderFns } from "./user-duties.vue?vue&type=template&id=e96cecec&"
import script from "./user-duties.vue?vue&type=script&lang=js&"
export * from "./user-duties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports